import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface PolicyData {
    title: string;
    code: string;
    description: string;
    owner: string;
    version: string;
    effective: string;
    reviewDate: string;
    status: string;
    review: string;
    category: string;
    content: string;
    scope: string;
    dataCollection: string;
    dataProcessing: string;
}

interface ModalProps {
    open: boolean;
    onClose: () => void;
    policy: PolicyData | null;
}

export default function ViewPolicyDetail({
    open,
    onClose,
    policy,
}: ModalProps) {
    if (!policy) return null;

    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog take_action_modal" style={{ maxWidth: '700px' }}>
                <div className="modal-body" style={{ padding: '0' }}>

                    {/* Header */}
                    <div className="modal_title" style={{ padding: '24px', borderBottom: '1px solid #f1f1f1', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div>
                            <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#B5651D', marginBottom: '4px', margin: 0 }}>{policy.title}</h2>
                            <span style={{ fontSize: '13px', color: '#94a3b8', fontWeight: '500' }}>{policy.code}</span>
                        </div>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            aria-label="Close"
                            style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#64748b' }}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <div style={{ padding: '24px' }}>
                        {/* Details Grid */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px', marginBottom: '32px' }}>
                            <div>
                                <label style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#94a3b8', display: 'block', marginBottom: '6px' }}>Category</label>
                                <span style={{ fontSize: '16px', fontWeight: '600', color: '#1e293b' }}>{policy.category}</span>
                            </div>
                            <div>
                                <label style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#94a3b8', display: 'block', marginBottom: '6px' }}>Status</label>
                                <span className={`status_chip active`} style={{ display: 'inline-block', backgroundColor: '#eefdf3', color: '#16a34a', padding: '4px 12px', borderRadius: '6px', fontSize: '13px', fontWeight: '500' }}>{policy.status}</span>
                            </div>
                            <div>
                                <label style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#94a3b8', display: 'block', marginBottom: '6px' }}>Version</label>
                                <span style={{ fontSize: '15px', fontWeight: '500', color: '#1e293b' }}>{policy.version}</span>
                            </div>
                            <div>
                                <label style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#94a3b8', display: 'block', marginBottom: '6px' }}>Owner</label>
                                <span style={{ fontSize: '15px', fontWeight: '500', color: '#1e293b' }}>{policy.owner}</span>
                            </div>
                            <div>
                                <label style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#94a3b8', display: 'block', marginBottom: '6px' }}>Effective Date</label>
                                <span style={{ fontSize: '15px', fontWeight: '500', color: '#1e293b' }}>{policy.effective}</span>
                            </div>
                            <div>
                                <label style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#94a3b8', display: 'block', marginBottom: '6px' }}>Review Date</label>
                                <span style={{ fontSize: '15px', fontWeight: '500', color: '#1e293b' }}>{policy.reviewDate}</span>
                            </div>
                        </div>

                        {/* Description */}
                        <div style={{ marginBottom: '24px' }}>
                            <label style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#94a3b8', display: 'block', marginBottom: '8px' }}>Description</label>
                            <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#475569', margin: 0 }}>{policy.description}</p>
                        </div>

                        {/* Policy Content */}
                        <div style={{ marginBottom: '24px' }}>
                            <label style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#94a3b8', display: 'block', marginBottom: '8px' }}>Policy Content</label>
                            <div style={{ backgroundColor: '#f8fafc', padding: '16px', borderRadius: '10px', border: '1px solid #f1f5f9' }}>
                                <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#64748b', margin: 0 }}>{policy.content}</p>
                            </div>
                        </div>

                        {/* Scope, Data Collection, Data Processing */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '20px' }}>
                            <div>
                                <label style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#94a3b8', display: 'block', marginBottom: '4px' }}>Scope</label>
                                <p style={{ fontSize: '14px', color: '#1e293b', margin: 0, fontWeight: '500' }}>{policy.scope}</p>
                            </div>
                            <div>
                                <label style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#94a3b8', display: 'block', marginBottom: '4px' }}>Data Collection</label>
                                <p style={{ fontSize: '14px', color: '#1e293b', margin: 0, fontWeight: '500' }}>{policy.dataCollection}</p>
                            </div>
                            <div>
                                <label style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#94a3b8', display: 'block', marginBottom: '4px' }}>Data Processing</label>
                                <p style={{ fontSize: '14px', color: '#1e293b', margin: 0, fontWeight: '500' }}>{policy.dataProcessing}</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </Modal>
    );
}
